import React from 'react'
import styles from "./FiringModal.module.css"
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import hy from 'date-fns/locale/hy';
import { useState } from 'react'
import { faCalendarDays, faFloppyDisk, faPenToSquare, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect } from 'react'
import { axiosInstance } from '../../Helpers/axiosInstance';

registerLocale('hy', hy);

export default function FiringModal({setFiredBy, who, firedBy, setGetDate, firedIndex}) {
    const [weapon, setWeapon] = useState('')
    const [count, setCount] = useState(0)
    const [countP, setCountP] = useState(0)
    const [fired, setfired] = useState([])
    const [mina, setMina] = useState()
    const [isMinaChecked, setIsMinaChecked] = useState(false)
    const [fire, setFire] = useState()
    const [isFireChecked, setIsFireChecked] = useState(false)
    const [signal, setSignal] = useState()
    const [isSignalChecked, setIsSignalChecked] = useState(false)
    const [date, setDate] = useState(null)
    const [time, setTime] = useState(null)
    const [showDate, setShowDate] = useState(false)
    const [fullDate, setFullDate] = useState()
    const [changeIndex, setChangeIndex] = useState(null)
    const [weaponTypes, setWeaponTypes] = useState([])
    
    useEffect(()=> {
        async function getWeapons() {
            const weapons = await axiosInstance.get('admin/weapons')
            if(weapons.status){
                setWeaponTypes(weapons.data.data.map(el => el.weapon_name))
            }
        }

        getWeapons()
    }, [])
    useEffect(() => {setFiredBy(p => ({...p, date: new Date(fullDate).getTime(), [who]: {weapon: fired, mina, fire, signal}}))}, [fired, mina, fire, signal, fullDate])
    useEffect(() => {
        if(who && firedBy[who]) {
            setfired(firedBy[who].weapon || [])
            setMina(firedBy[who].mina || 0)
            setIsMinaChecked(!!firedBy[who].mina)
            setFire(firedBy[who].fire || 0)
            setIsFireChecked(!!firedBy[who].fire)
            setSignal(firedBy[who].signal || 0)
            setIsSignalChecked(!!firedBy[who].signal)

        }else if(who && firedBy[firedIndex][who]) {
            setfired(firedBy[firedIndex][who].weapon|| [])
            setMina(firedBy[firedIndex][who].mina || 0)
            setIsMinaChecked(!!firedBy[firedIndex][who].mina)
            setFire(firedBy[firedIndex][who].fire || 0)
            setIsFireChecked(!!firedBy[firedIndex][who].fire)
            setSignal(firedBy[firedIndex][who].signal || 0)
            setIsSignalChecked(!!firedBy[firedIndex][who].signal)
            setFullDate(Number(firedBy[firedIndex].date))
setFiredBy(firedBy[firedIndex])
        }
        else{
            setfired([])
            setMina(0)
            setFire(0)
            setSignal(0)
        }
    }, [who])
    const addToFired = () => {
        if (weapon && count && countP) {
            const newFired = {
                weapon_type: weapon,
                firing_count: count,
                bullet_count: countP
            }
            setfired([...fired, newFired])
            setWeapon('')
            setCount(0)
            setCountP(0)
        } else {
            alert("Խնդրում ենք լրացնել բոլոր դաշտերը")
        }
    }

    const editFired = () => {
        if (weapon && count && countP) {
            const newFired = {
                weapon_type: weapon,
                firing_count: count,
                bullet_count: countP
            }
            let updated = [...fired]
            updated[changeIndex] = newFired;
            setfired(updated)
            setChangeIndex(null)
            setWeapon('')
            setCount(0)
            setCountP(0)
        } else {
            alert("Խնդրում ենք լրացնել բոլոր դաշտերը")
        }
    }

    const deleteFired = (index) => {
        let updated = [...fired]
        updated.splice(index, 1);
        setfired(updated);
    }

    function getDate(date){ const parts = new Intl.DateTimeFormat('en-GB').formatToParts(date)
         const day = parts.find(p => p.type === 'day').value;
         const month = parts.find(p => p.type === 'month').value;
         const year = parts.find(p => p.type === 'year').value;
         const formatted = `${day}/${month}/${year}`;
         return formatted;
    }

        function unGetDate(date){ 
            if(date){
                const [day, month, year]  = date.split("/")
                const formatted = `${month}/${day}/${year}`;
                return formatted;

            }
    }
    function getTimeOfFiring(){
        const date = new Date(Number(firedBy[firedIndex].date))
        const hours = date.getHours()
        const minutes = date.getMinutes()
        const result = `${hours < 10 ? `0${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes}`
        setTime(result)
        return result
    }
    useEffect(() => {
        if(date && time) {
            const str = date + " " + time;
            const [datePart, timePart] = str.split(" ");
            const [day, month, year] = datePart.split("/");
            const [hours, minutes] = timePart.split(":")
            setFullDate(new Date(year, month - 1, day, hours, minutes))
           setGetDate(new Date(year, month - 1, day, hours, minutes).getTime())
        }
    }, [date, time])
    const handleDateModal = (e) => {
        e.stopPropagation();
        setShowDate(!showDate);
    }

    const setEdit = (index) => {
        setChangeIndex(index);
        setWeapon(fired[index].weapon_type);
        setCount(fired[index].firing_count);
        setCountP(fired[index].bullet_count);
    }
  return (
        <div>
            <div className={styles['firing-form']}>
                <div>
                    <label htmlFor="weapon">Զինատեսակ</label>
                    <select name="weapon" id="weapon" value={weapon} onChange={(e) => setWeapon(e.target.value)}>
                        <option value="">Ընտրել զենքը</option>
                        {weaponTypes.map((item, index) => (
                            <option key={index} value={item}>{item}</option>
                        ))}
                    </select>
                </div>
                <div>
                    <label htmlFor="count">Կրակոցների քանակ</label>
                    <input type="number" id="count" value={count} onChange={(e) => setCount(e.target.value)} />
                </div>
                <div>
                    <label htmlFor="countP">Փամփուշտների քանակ</label>
                    <input type="number" id="countP" value={countP} onChange={(e) => setCountP(e.target.value)} />
                </div>
                {changeIndex || changeIndex === 0 ? <FontAwesomeIcon className={styles['adding']} icon={faFloppyDisk} onClick={editFired}/> :
                <FontAwesomeIcon className={styles['adding']} icon={faPlus} onClick={addToFired}/>}
            </div>
            {fired.length > 0 && fired.map((item, index) => (
                <div key={index} className={styles['fired-item']}>
                    <p>{index + 1}. {item.weapon_type} - {item.firing_count} կրակոց, {item.bullet_count} փամփուշտ</p>
                    <div>
                        <button onClick={() => setEdit(index)}><FontAwesomeIcon icon={faPenToSquare} className={styles["edit"]} title="Խմբագրել"/></button>
                        <button onClick={() => deleteFired(index)}><FontAwesomeIcon icon={faTrash} className={styles["edit"]} title="Ջնջել"/></button>
                    </div>
                </div>
            ))}
            <p className='w-full text-center'>{who === "us" ? "Մեր պահպանության գոտում" : "Հակառակորդի պահպանության գոտում"}</p>
            <div className={styles['others']}>
                <div className={styles['others-item']}>
                    <label htmlFor='mina'>Ական</label>
                    <input type="checkbox" id="mina" checked={isMinaChecked} onChange={() => setIsMinaChecked(!isMinaChecked)}/>
                    {isMinaChecked && <input type="number" className={styles['input-value']} value={mina} onChange={(e) => setMina(e.target.value)} placeholder='Քանակ'/>}
                </div>
                <div className={styles['others-item']}>
                    <label htmlFor='fire'>Հրդեհ</label>
                    <input type="checkbox" id="fire" checked={isFireChecked} onChange={() => setIsFireChecked(!isFireChecked)}/>
                    {isFireChecked &&<input type="number" className={styles['input-value']} value={fire} onChange={(e) => setFire(e.target.value)} placeholder='Քանակ'/>}
                </div>
                <div className={styles['others-item']}>
                    <label htmlFor='signal'>Ազդանշանային</label>
                    <input type="checkbox" id="signal" checked={isSignalChecked} onChange={() => setIsSignalChecked(!isSignalChecked)}/>
                    {isSignalChecked && <input className={styles['input-value']} type="number" value={signal} onChange={(e) => setSignal(e.target.value)} placeholder='Քանակ'/>}
                </div>
            </div>
            <div className={styles['date-time']}>
                <p>Գնդակոծման ժամանակը</p>
                <div onClick={handleDateModal} className="flex items-center">
                    <FontAwesomeIcon icon={faCalendarDays} className={styles["calendar-icon"]}/>
                    <DatePicker 
                        selected={!date 
                            ? firedBy[firedIndex] && firedBy[firedIndex].date 
                            ? unGetDate(getDate(firedBy[firedIndex].date)) 
                            : null
                            : unGetDate(date)}
                        onChange={(date) => setDate(getDate(date))}
                        locale="hy"
                        dateFormat="dd MMMM yyyy" 
                        className='border border-gray-500 rounded-md mx-2 px-1'
                />
                </div>
                <input className='border border-gray-500 rounded-md px-1' type="time" value={!time
                        ? (firedBy[firedIndex] && firedBy[firedIndex].date ? getTimeOfFiring() : ""): time}
             onChange={(e) => setTime(e.target.value)} /> 
            </div> 
           
        </div>
  )
}
